
export const baseScale = 100;

const ppi = 96 * window.devicePixelRatio;
const mm2in = 25.4;
export const mm2px = (mm: number, scale: number) => scale * mm * ppi / (mm2in * baseScale);